module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app bg-gray",
    attrs: {
      "id": "gwi-voucherRegister"
    }
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('section', {
    staticClass: "flex-row choose-type-section",
    class: _vm.validVoucherCount ? '' : 'disabled',
    on: {
      "click": function($event) {
        return _vm.registerCard()
      }
    }
  }, [_c('div', {
    staticClass: "flex-1 choose-type-register-logo"
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (!_vm.validVoucherCount) ? _c('div', {
    staticClass: "voucher-choose-type-bottom-tips"
  }, [_c('p', {
    staticClass: "f-strongest"
  }, [_vm._v("\n        您当前已绑定的就诊凭证已满，无法绑定更多就诊凭证\n      ")])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-3 flex-col flex-justify-center"
  }, [_c('p', {
    staticClass: "f-large f-strong"
  }, [_vm._v("申请电子健康卡")]), _vm._v(" "), _c('p', {
    staticClass: "f-small f-normal",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_vm._v("\n          通过本人身份证信息完成办卡\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-736234d8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/voucher/VoucherChooseType.vue
// module id = 852
// module chunks = 0